module.exports = __webpack_public_path__ + "img/people.feba7fcb.png";